/* LAYOUT */
export const CHANGE_LAYOUT = "CHANGE_LAYOUT"
export const CHANGE_LAYOUT_MODE = "CHANGE_LAYOUT_MODE"
export const CHANGE_LAYOUT_WIDTH = "CHANGE_LAYOUT_WIDTH"
export const CHANGE_SIDEBAR_THEME = "CHANGE_SIDEBAR_THEME"
export const CHANGE_SIDEBAR_TYPE = "CHANGE_SIDEBAR_TYPE"

// topbar
export const CHANGE_TOPBAR_THEME = "CHANGE_TOPBAR_THEME"

// show sidebar
export const SHOW_SIDEBAR = "SHOW_SIDEBAR"
export const TOGGLE_LEFTMENU = "TOGGLE_LEFTMENU"
export const VIEW_TICKETS = "VIEW_TICKETS";
export const GET_TICKET_BY_ID = "GET_TICKET_BY_ID";


export const FETCH_TICKETS_SUCCESS = "FETCH_TICKETS_SUCCESS";
export const FETCH_TICKETS_FAILURE = "FETCH_TICKETS_FAILURE";

export const FETCH_USERS_SUCCESS = "FETCH_USERS_SUCCESS";
export const FETCH_USERS_FAILURE = "FETCH_USERS_FAILURE";

export const CREATE_TICKETS_SUCCESS = "CREATE_TICKETS_SUCCESS";
export const CREATE_TICKETS_FAILURE = "CREATE_TICKETS_FAILURE";


export const UPDATE_TICKETS_SUCCESS = "UPDATE_TICKETS_SUCCESS";
export const UPDATE_TICKETS_FAILURE = "UPDATE_TICKETS_FAILURE";

export const UPDATE_TICKET_STATUS_SUCCESS = "UPDATE_TICKET_STATUS_SUCCESS";
export const UPDATE_TICKET_STATUS_FAILURE = "UPDATE_TICKET_STATUS_FAILURE";

export const ASSIGN_TICKET_SUCCESS = "UPDATE_TICKET_STATUS_SUCCESS";
export const ASSIGN_TICKET_FAILURE = "UPDATE_TICKET_STATUS_FAILURE";

export const FETCH_TICKET_BY_ID_SUCCESS = "FETCH_TICKET_BY_ID_SUCCESS";
export const FETCH_TICKET_BY_ID_FAILURE = "FETCH_TICKET_BY_ID_FAILURE";

/* RIGHT SIDEBAR */
export const SHOW_RIGHT_SIDEBAR = "SHOW_RIGHT_SIDEBAR"

export const SET_CURRENT_PAGE = "SET_CURRENT_PAGE";
